import { Award, Heart, MoveRight, Shield, Target } from "lucide-react";
import { images } from "../../assets/assets";
import Navbar from "../../Components/Navbar";
import { Link } from "react-router-dom";
import Footer from "../../Components/Footer";
import { useEffect } from "react";

const VisionAndMission = () => {
  const FacilityData = [
    {
      img: images.FacilityOne,
      label: "Advanced Operation Theatres",
    },
    {
      img: images.FacilityTwo,
      label: "Well-equipped ICU & Emergency Unit",
    },
    {
      img: images.FacilityThree,
      label: "Modern Diagnostic & Pathology Lab",
    },
    {
      img: images.FacilityFour,
      label: "Comfortable Patient Rooms",
    },
    {
      img: images.FacilityFive,
      label: "Pharmacy & Medical Store",
    },
  ];
  return (
    <div className="font-lato">
      <Navbar />
      <div className="bg-[#F7F7F7B2] py-4 flex justify-center px-4">
        <div className="flex gap-2 items-center">
          <img
            src={images.Logo}
            alt="logo"
            className="w-[60px] h-[60px] md:w-[75px] md:h-[75px]"
          />
          <p className="font-bold text-[18px] sm:text-[20px] md:text-[22px]">
            Vision & Mission
          </p>
        </div>
      </div>
      {/* Vision and Mission */}
      <div className="py-8 grid grid-cols-1 md:grid-cols-2 gap-6 max-w-[1100px] mx-auto px-4">
        <div className="border border-[#B9B9B9] rounded-[20px] px-6 py-6 group hover:border-transparent hover:shadow-[0px_10px_40px_0px_#CECDDA66] hover:-translate-y-2 hover:bg-[#F8FAFF] active:scale-[0.98] transition-all duration-500">
          <h1 className="max-w-[402px] font-semibold leading-[1.2] text-[24px] sm:text-[28px] md:text-[32px] mb-4">
            A Vision for Excellence in Medical Care
          </h1>
          <p className="font-openSans text-[14px] sm:text-[16px] md:text-[17px] lg:text-[18px] text-gray-700">
            Our vision is to set new standards in healthcare by delivering
            excellence in medical services, driven by innovation, advanced
            technology, and a patient-first approach. We strive to create a
            healthcare environment where quality treatment, safety, and
            compassion come together to ensure the best possible outcomes for
            every patient.
          </p>
        </div>
        <div className="border border-[#B9B9B9] rounded-[20px] px-6 py-6 group hover:border-transparent hover:shadow-[0px_10px_40px_0px_#CECDDA66] hover:-translate-y-2 hover:bg-[#FFF9F9] active:scale-[0.98] transition-all duration-500">
          <h1 className="max-w-[238px] font-semibold leading-[1.2] text-[24px] sm:text-[28px] md:text-[32px] mb-4">
            Mission of Trust & Care
          </h1>
          <div className="border-l-4 border-[#4CD9E5] py-2 px-3 mt-4 group-hover:bg-white group-hover:shadow-sm rounded-r-md transition-all duration-300">
            <p className="font-openSans text-[13px] sm:text-[14px] md:text-[15px] lg:text-[16px] text-gray-700">
              To provide accessible and affordable healthcare for all
            </p>
          </div>
          <div className="border-l-4 border-[#E3A1A1] py-2 px-3 mt-3 group-hover:bg-white group-hover:shadow-sm rounded-r-md transition-all duration-300">
            <p className="font-openSans text-[13px] sm:text-[14px] md:text-[15px] lg:text-[16px] text-gray-700">
              To deliver accurate diagnosis and effective treatment using modern
              technology
            </p>
          </div>
          <div className="border-l-4 border-[#8A38F5] py-2 px-3 mt-3 group-hover:bg-white group-hover:shadow-sm rounded-r-md transition-all duration-300">
            <p className="font-openSans text-[13px] sm:text-[14px] md:text-[15px] lg:text-[16px] text-gray-700">
              To ensure patient safety, comfort, and satisfaction
            </p>
          </div>
          <div className="border-l-4 border-[#B8957A] py-2 px-3 mt-3 group-hover:bg-white group-hover:shadow-sm rounded-r-md transition-all duration-300">
            <p className="font-openSans text-[13px] sm:text-[14px] md:text-[15px] lg:text-[16px] text-gray-700">
              To maintain ethical and transparent medical practices
            </p>
          </div>
          <div className="border-l-4 border-[#F2868D] py-2 px-3 mt-3 group-hover:bg-white group-hover:shadow-sm rounded-r-md transition-all duration-300">
            <p className="font-openSans text-[13px] sm:text-[14px] md:text-[15px] lg:text-[16px] text-gray-700">
              To promote preventive healthcare and community wellness
            </p>
          </div>
        </div>
      </div>
      {/* Core Values */}
      <h1 className="text-[22px] sm:text-[26px] md:text-[28px] font-semibold text-center mt-6 md:mt-8 leading-[1.2] px-4">
        Our Core Values
      </h1>
      <p className="text-[14px] sm:text-[16px] md:text-[17px] lg:text-[18px] text-center max-w-[750px] mx-auto mt-3 mb-6 leading-[1.4] px-4 text-gray-600">
        Our core values are the foundation of our healthcare philosophy,
        ensuring that every patient receives compassionate, ethical, and
        high-quality medical care in a safe and supportive environment.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 max-w-[900px] mx-auto my-10 px-4">
        <div className="border border-[#B9B9B9] p-6 rounded-[20px] text-center group hover:border-transparent hover:shadow-[0px_10px_35px_0px_#CECDDA66] hover:-translate-y-2 hover:bg-[#F8FAFF] active:scale-[0.98] transition-all duration-500">
          <div className="bg-[#F1F1F1] p-3 md:p-4 rounded-full inline-block group-hover:bg-white group-hover:shadow-md transition-all duration-500">
            <Heart
              color="#000"
              className="w-10 h-10 md:w-12 md:h-12 group-hover:text-red-500 transition-colors duration-500"
            />
          </div>
          <p className="font-semibold text-[16px] sm:text-[18px] md:text-[20px] my-3">
            Compassion
          </p>
          <p className="max-w-[150px] mx-auto text-[#545454] text-[13px] sm:text-[14px] md:text-[15px] lg:text-[16px] leading-[1.4]">
            We treat every patient with empathy and care
          </p>
        </div>
        <div className="border border-[#B9B9B9] p-6 rounded-[20px] text-center group hover:border-transparent hover:shadow-[0px_10px_35px_0px_#CECDDA66] hover:-translate-y-2 hover:bg-[#F8FAFF] active:scale-[0.98] transition-all duration-500">
          <div className="bg-[#F1F1F1] p-3 md:p-4 rounded-full inline-block group-hover:bg-white group-hover:shadow-md transition-all duration-500">
            <Shield
              color="#000"
              className="w-10 h-10 md:w-12 md:h-12 group-hover:text-blue-500 transition-colors duration-500"
            />
          </div>
          <p className="font-semibold text-[16px] sm:text-[18px] md:text-[20px] my-3">
            Integrity
          </p>
          <p className="max-w-[150px] mx-auto text-[#545454] text-[13px] sm:text-[14px] md:text-[15px] lg:text-[16px] leading-[1.4]">
            Honesty and transparency in all our practices
          </p>
        </div>
        <div className="border border-[#B9B9B9] p-6 rounded-[20px] text-center group hover:border-transparent hover:shadow-[0px_10px_35px_0px_#CECDDA66] hover:-translate-y-2 hover:bg-[#F8FAFF] active:scale-[0.98] transition-all duration-500">
          <div className="bg-[#F1F1F1] p-3 md:p-4 rounded-full inline-block group-hover:bg-white group-hover:shadow-md transition-all duration-500">
            <Award
              color="#000"
              className="w-10 h-10 md:w-12 md:h-12 group-hover:text-yellow-500 transition-colors duration-500"
            />
          </div>
          <p className="font-semibold text-[16px] sm:text-[18px] md:text-[20px] my-3">
            Excellence
          </p>
          <p className="max-w-[150px] mx-auto text-[#545454] text-[13px] sm:text-[14px] md:text-[15px] lg:text-[16px] leading-[1.4]">
            Committed to the highest standards of medical care
          </p>
        </div>
        <div className="border border-[#B9B9B9] p-6 rounded-[20px] text-center group hover:border-transparent hover:shadow-[0px_10px_35px_0px_#CECDDA66] hover:-translate-y-2 hover:bg-[#F8FAFF] active:scale-[0.98] transition-all duration-500">
          <div className="bg-[#F1F1F1] p-3 md:p-4 rounded-full inline-block group-hover:bg-white group-hover:shadow-md transition-all duration-500">
            <Target
              color="#000"
              className="w-10 h-10 md:w-12 md:h-12 group-hover:text-green-500 transition-colors duration-500"
            />
          </div>
          <p className="font-semibold text-[16px] sm:text-[18px] md:text-[20px] my-3">
            Innovation
          </p>
          <p className="max-w-[150px] mx-auto text-[#545454] text-[13px] sm:text-[14px] md:text-[15px] lg:text-[16px] leading-[1.4]">
            Embracing modern technology and best practices
          </p>
        </div>
      </div>
      <div className="py-10 md:py-14 bg-[#F7F7F7B2]    transition-all duration-500   hover:bg-[#F0EBFFB2] border border-transparent hover:border-white my-10 md:my-16">
        <h1 className="max-w-[550px] text-center text-[22px] sm:text-[26px] md:text-[28px] lg:text-[32px] font-semibold mx-auto leading-[1.3]">
          Meet Our <br /> Healthcare Experts
        </h1>
        <p className="max-w-[600px] font-openSans text-[14px] sm:text-[16px] md:text-[17px] lg:text-[18px] mx-auto text-center mt-3">
          Our team of highly qualified and experienced doctors is dedicated to
          providing the best medical care. Each specialist focuses on
          personalized treatment and patient comfort.
        </p>
        <div className="flex flex-wrap gap-4 justify-center mt-8">
          <Link
            to="/doctors"
            className="bg-[#1975FF] rounded-[10px] py-1 pr-1 pl-4 flex items-center gap-2 text-[14px] font-semibold text-white hover:bg-[#1560d4] active:bg-[#1050b8] active:scale-95 transition-all duration-200 shadow-md hover:shadow-lg group"
          >
            Meet our Doctors{" "}
            <span className="p-2 bg-white rounded-full transition-transform duration-300 group-hover:scale-110">
              <MoveRight color="#000" className="rotate-[-38deg] w-4 h-4" />
            </span>
          </Link>
        </div>
      </div>
      <h1 className="text-[22px] sm:text-[26px] md:text-[28px] lg:text-[32px] font-semibold leading-[1.3] text-center mt-10 md:mt-12 px-4">
        Modern Facilities for Better <br className="hidden md:block" /> Patient
        Care
      </h1>
      <p className="max-w-[700px] mx-auto font-openSans text-[14px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-[1.4] mt-3 md:mt-4 text-center px-4 text-gray-600">
        Our team of highly qualified and experienced doctors is dedicated to
        providing the best medical care. Each specialist focuses on personalized
        treatment and patient comfort.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-3 max-w-[1200px] mx-auto my-10 mb-14 px-4">
        {FacilityData.map((facility, idx) => (
          <div
            key={idx}
            className="h-[230px] px-4 py-4 rounded-[15px] w-full bg-cover bg-center flex items-end text-white group overflow-hidden relative cursor-pointer hover:shadow-2xl hover:-translate-y-2 active:scale-[0.97] transition-all duration-500"
            style={{
              backgroundImage: `linear-gradient(180deg, rgba(102, 102, 102, 0) 40.4%, rgba(23, 23, 23, 0.5) 65.87%, rgba(14, 14, 14, 0.7) 81.25%, rgba(0, 0, 0, 0.85) 100%),
                url(${facility.img})
                `,
            }}
          >
            <p className="font-extrabold text-[14px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-[1.3] relative z-10 group-hover:text-blue-200 transition-colors duration-300">
              {facility.label}
            </p>
          </div>
        ))}
      </div>
      <Footer />
    </div>
  );
};

export default VisionAndMission;
